<div>

    <table>

      <thead>
        <tr>
          <!-- <th>Day</th> -->
          <th>From Time</th>
          <th>To Time</th>
          <th>EngageMentLevel</th>
        </tr>

      </thead>
      <tbody>
        <!-- <tr> <td *ngIf="labAvailableTimingsRes.monday">Monday</td></tr> -->
     
        <tr *ngFor="let obj of labAvailableTimings">
            <td *ngIf="data"></td>
            <td *ngIf="obj">{{obj.start_time}}</td> 
            <td *ngIf="obj">{{obj.end_time}}</td> 
            <td *ngIf="obj">{{obj.engage_at}}</td> 
          </tr>

    

    


      </tbody>
    </table>

  </div>
